<template>
  <div
    class="main-wrapper"
    :class="{
      'main-wrapper--sidebar-closed': hideSidebar && hasSidebar,
      'main-wrapper--no-sidebar': !hasSidebar
    }"
  >
    <main :class="{ 'container-fluid': useContainer }">
      <div
        class="content-wrapper"
        :class="{
          'content-wrapper--with-footer': showFooter,
          'content-wrapper--with-navbar': showNavbar
        }"
      >
        <slot></slot>
      </div>
    </main>
    <AppFooter v-if="!hideFooter" />
  </div>
</template>

<script>
import AppFooter from '@/common/components/AppFooter.vue';

export default {
  components: {
    AppFooter
  },
  props: {
    showFooter: {
      type: Boolean,
      default: true
    },
    useContainer: {
      type: Boolean,
      default: true
    },
    hasSidebar: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      showStaffWarning: false
    };
  },
  computed: {
    hideSidebar() {
      return this.$store.state.menus.hideSidebar;
    },
    hideFooter() {
      return this.$route.meta.hideFooter || !this.showFooter;
    },
    showNavbar() {
      return this.$route.query.navbar !== 'false';
    }
  }
};
</script>

<style lang="scss" scoped>
$sidebar-width: rem-calc(40px);

.main-wrapper {
  position: relative;
  min-height: $main-height;

  transition: margin 0.2s ease-in-out;

  &--with-background {
    background: color('neutral-background');
  }

  @include breakpoint(large) {
    margin-left: 22rem;

    [dir='rtl'] & {
      margin-left: 0;
      margin-right: 22rem;
    }
  }

  &--no-sidebar {
    margin-left: 0;

    [dir='rtl'] & {
      margin-right: 0;
    }
  }

  &--sidebar-closed {
    @include breakpoint(large) {
      margin-left: calc(#{$sidebar-width} + 1px);

      [dir='rtl'] & {
        margin-left: 0;
        margin-right: calc(#{$sidebar-width} + 1px);
      }
    }
  }
}

.content-wrapper {
  position: relative;

  padding-top: 0.1px; // No margin collapsing

  &--with-footer {
    display: flex;
    flex-direction: column;
    $header-height: 60;
    $footer-height: 65;
    $mobile-footer-height: 75;
    padding-bottom: 1rem;
    min-height: calc(100vh - #{$mobile-footer-height}px - #{$header-height}px);

    &:not(.content-wrapper--with-navbar) {
      min-height: calc(100vh - #{$mobile-footer-height}px);
    }

    @include breakpoint(small) {
      min-height: calc(100vh - #{$footer-height}px - #{$header-height}px);

      &:not(.content-wrapper--with-navbar) {
        min-height: calc(100vh - #{$footer-height}px);
      }
    }
  }
}
</style>
